import { render, staticRenderFns } from "./TheApprovalOrders.vue?vue&type=template&id=19a3b96e&scoped=true"
import script from "./TheApprovalOrders.vue?vue&type=script&lang=js"
export * from "./TheApprovalOrders.vue?vue&type=script&lang=js"
import style0 from "./TheApprovalOrders.vue?vue&type=style&index=0&id=19a3b96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3b96e",
  null
  
)

export default component.exports